import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectionChangedEvent } from 'ag-grid-enterprise';
import { SiteUser, User } from 'src/app/classes/models';
import { SiteService } from 'src/app/services/site.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-assign-users-to-site-modal',
  templateUrl: './assign-users-to-site-modal.component.html',
  styleUrls: ['./assign-users-to-site-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AssignUsersToSiteModalComponent implements OnInit {
  @Input() SiteId?: number;

  shouldNotify: boolean = false;
  isPrimary: boolean = false;
  User?: User;
  SiteUser?: SiteUser;
  disableSaveBtn: boolean = false;

  suppliedGridQueryData: { [key: string]: any } = {};

  constructor(
    private ToastService: ToastService,
    private activeModal: NgbActiveModal,
    private SiteService: SiteService
  ) {}

  onSelectionChange(event: SelectionChangedEvent) {
    const { api } = event;

    if (api) {
      const users: User[] = api.getSelectedRows();
      const user: User = users[0];
      this.User = user;
    }
  }

  close(reason?: any) {
    this.activeModal.close(reason);
  }

  save() {
    if (!this.User || !this.User.id) {
      throw this.ToastService.addErrorToast('Error', 'No User selected.');
    }

    this.SiteUser = {
      SiteId: this.SiteId,
      UserId: this.User.id,
      isPrimary: this.isPrimary,
      shouldNotify: this.shouldNotify
    };

    if (!this.SiteUser) {
      throw this.ToastService.addErrorToast('Error', 'No SiteUser to create.', {
        returnError: true
      });
    }

    this.disableSaveBtn = true;

    this.SiteService.saveSiteUser(this.SiteUser).subscribe({
      next: (SiteUser: SiteUser) => {
        this.close(SiteUser);
      },
      error: (err) => {
        this.disableSaveBtn = false;
        throw this.ToastService.addErrorToast('Error', err.message, {
          returnError: true
        });
      }
    });
  }

  ngOnInit(): void {
    if (!this.SiteId) {
      throw this.ToastService.addErrorToast('Error', 'No Site ID found.', {
        returnError: true
      });
    }

    this.SiteService.getSiteUsers({
      SiteId: this.SiteId
    }).subscribe({
      next: (SiteUsers: SiteUser[]) => {
        if (SiteUsers && SiteUsers.length > 0) {
          const userIds = SiteUsers.map((siteUser) => siteUser.UserId);

          Object.assign(this.suppliedGridQueryData, {
            id: JSON.stringify({ $notIn: userIds })
          });
        }
      }
    });
  }
}
